/// <reference path="DOMAttached.js" />

class PostingVisibility extends DOMAttached {
	constructor(el) {
		super(el);
		this.all = this.el.querySelector('.all');
		this.friends = this.el.querySelector('.friends');
		this.friendslist = this.el.querySelector('ul');
		this.safeObserve(this.all, 'click', this.applyConstraints.bind(this));
		this.safeObserve(this.friends, 'click', this.applyConstraints.bind(this));

		if (this.all.checked) {
			this.friends.checked = true;
		}

		PostingVisibility.instance = this;
		this.applyConstraints();
	}

	applyConstraints() {
		if (this.all.checked) {
			this.friends.disabled = true;
			this.friends.checked = false;
		} else {
			this.friends.disabled = false;
		}

		if (this.friendslist != undefined) {
			if (this.friends.checked || this.all.checked) {
				this.friendslist.querySelectorAll('input').forEach(function(el) {
					el.disabled = true;
					el.checked = false;
				});
				if (typeof(FriendslistCreateOnTheFly) != 'undefined' && typeof(FriendslistCreateOnTheFly.instance) != 'undefined') {
					FriendslistCreateOnTheFly.instance.staticEnable(false);
				}
			} else {
				this.friendslist.querySelectorAll('input').forEach(function(el) { el.disabled = false; });
				if (typeof(FriendslistCreateOnTheFly) != 'undefined' && typeof(FriendslistCreateOnTheFly.instance) != 'undefined') {
					FriendslistCreateOnTheFly.instance.staticEnable(true);
				}
			}
		}
	}

	uncheckAllAndFriends() { //remote uncheck
		this.all.checked = false;
		this.friends.checked = false;
		this.applyConstraints();
	}
}
